import { TranslocoFallbackStrategy } from '@ngneat/transloco';


export class CustomFallbackStrategy implements TranslocoFallbackStrategy {
  getNextLangs(failedLang: string) {
    const lang = failedLang.split(/[-_]/)[0];
    return [lang, 'en'];
  }
}
